<script setup>
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import { computed, ref } from 'vue';
import { Line } from 'vue-chartjs';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
);

const {
    labels,
    datasets,
    enableAxis2 = false,
    reverseAxis1 = false,
    reverseAxis2 = false,
    axis1BeginAtZero = false,
    minAxis1 = null,
    maxAxis1 = null,
} = defineProps({
    labels: {
        type: Array,
        required: true,
    },
    datasets: {
        type: Array,
        required: true,
    },
    enableAxis2: {
        type: Boolean,
        required: false,
    },
    reverseAxis1: {
        type: Boolean,
        required: false,
    },
    reverseAxis2: {
        type: Boolean,
        required: false,
    },
    axis1BeginAtZero: {
        type: Boolean,
        required: false,
    },
    minAxis1: {
        type: Number,
        required: false,
    },
    maxAxis1: {
        type: Number,
        required: false,
    },
});

const chartData = computed(() => {
    return {
        labels,
        datasets,
    };
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            display: false,
            grid: {
                display: false,
            },
        },
        ...(enableAxis2
            ? {
                  y: {
                      position: 'left',
                      reverse: reverseAxis1,
                      display: false,
                      beginAtZero: axis1BeginAtZero,
                      min: minAxis1,
                      max: maxAxis1,
                  },
                  y1: {
                      position: 'right',
                      reverse: reverseAxis2,
                      display: false,
                  },
              }
            : {
                  y: {
                      reverse: reverseAxis1,
                      display: false,
                      beginAtZero: axis1BeginAtZero,
                      min: minAxis1,
                      max: maxAxis1,
                  },
              }),
    },
    elements: {
        point: {
            radius: 0,
        },
    },
    animation: {
        duration: 0,
    },
    hover: { mode: null },
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltips: {
            enabled: false,
        },
    },
});
</script>

<template>
    <div class="pointer-events-none h-6 w-20 overflow-hidden rounded-sm">
        <Line :data="chartData" :options="chartOptions" />
    </div>
</template>
